import { Controller } from "@hotwired/stimulus"

// Auto-navigates to a target URL when the controller connects.
// Used by the contact-import success card to send the user straight to
// the matching profiles_researches?relation_state=pending_sent page once
// the import job broadcasts its `completed` state. The brief delay lets
// the user see the "Import terminé" confirmation before the redirect.
declare const Turbo: { visit(url: string): void } | undefined

export default class extends Controller {
  static values = {
    url: String,
    delayMs: { type: Number, default: 1500 }
  }

  declare urlValue: string
  declare delayMsValue: number

  private timer: number | null = null

  connect() {
    if (!this.urlValue) return

    this.timer = window.setTimeout(() => {
      if (typeof Turbo !== "undefined") {
        Turbo.visit(this.urlValue)
      } else {
        window.location.assign(this.urlValue)
      }
    }, this.delayMsValue)
  }

  disconnect() {
    if (this.timer) {
      window.clearTimeout(this.timer)
      this.timer = null
    }
  }
}
